import { Component, OnInit, Inject } from '@angular/core';
import { RolesService } from 'src/app/services/roles.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RolesMainComponent } from '../roles-main/roles-main.component';

@Component({
  selector: 'app-edit-role',
  templateUrl: './edit-role.component.html',
  styleUrls: ['./edit-role.component.css']
})
export class EditRoleComponent implements OnInit {
  RoleName:string = ""
  submitted = false
  PermissionsName = "Choose Permission"
  all_premiosn:any
  permiosn_choice:any = []
  permissions_arr:any = []

  constructor(private rest : RolesService ,
     public dialogRef: MatDialogRef<RolesMainComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any){}

  ngOnInit(){
    console.log(this.data)
    this.getPermiosn()
  }

   getData(id:any){
     let permiosn :any = []
     this.rest.roleDetails(id).subscribe((res:any) => {
       console.log(res)
       this.RoleName = res.name
       this.permiosn_choice = res.rolePermissions

       res.rolePermissions.forEach((element:any) => {
        this.all_premiosn.forEach((item:any) => {
          if(element.name == item.name){
             permiosn.push(item)
            console.log(item)
          }
        });   
      });
      this.permissions_arr = permiosn
      console.log("this.permissions_arr ",this.permissions_arr )
      // this.permissions_arr = ['Retrieve operator']
     })
   }

   getPermiosn(){
    this.rest.retrivePermison().subscribe((res:any) => {
      console.log(res)
      this.all_premiosn = res
      this.getData(this.data.id)
    })
  }

  getPerItem(item:any){
    for(let i = 0 ; i < this.permiosn_choice.length ; i++){
      if(item.name == this.permiosn_choice[i].name){
        this.permiosn_choice.splice(i,1)
      }
    }
    this.permiosn_choice.push(item)
  }

  addrole(){
    this.submitted = true
    console.log(this.RoleName)
    if(this.RoleName != "" && this.permiosn_choice.length != 0 ){
      let data = {
        name : this.RoleName,
        permiosn : this.permissions_arr,
        roleId:this.data.id
      }
      console.log(data)
      this.dialogRef.close(data);
    }

  }

  getInput(event:any){
    this.RoleName = event.target.value
  }

}
